// extracted by mini-css-extract-plugin
export default {"root":"ExpandableBio_root__X9VT5","expandableText":"ExpandableBio_expandableText__7L1l3","showMore":"ExpandableBio_showMore__OODEN","arrowIcon":"ExpandableBio_arrowIcon__Oe7Ak"};